import {UyapRequest} from "./UyapRequest";
import JSZip from "jszip";
import {ResponseType} from "axios";

export class MtsTakipTalebiIndirTalep {
    dosyaId: any = "";
}

export interface MtsTakipTalebiIndirCevap {
    file: Blob
}


export default class MtsTakipTalebiIndir extends UyapRequest<MtsTakipTalebiIndirTalep, MtsTakipTalebiIndirCevap> {
    delayTime = 1000;

    constructor() {
        super();
    }

    getMethod(): 'GET' | 'POST' {
        return 'GET';
    }

    getSpinnerMessage(){
        return "MTS takip talebi indiriliyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getResponseType(): ResponseType {
        return 'blob';
    }

    getMockResponse(): Blob {
        return new Blob();
    }

    getUrl(): string {
        //https://avukatbeta.uyap.gov.tr/mtsTakipTalebiHazirla_brd.avukat?dosyaId=
        return this.ImzaClientAddr + "mtsTakipTalebiHazirla_brd.avukat";
    }

    async parse(data: any): Promise<MtsTakipTalebiIndirCevap> {
        return new Promise((resolve, reject) => {
            console.log("MtsTakipTalebiIndirCevap",data);
            
            if (!data) {
                return reject(new Error("Boş veya geçersiz dosya alındı"));
            }
            
            let blobData = data;
            let reader = new FileReader();
            
            reader.onerror = () => {
                reject(new Error("Dosya okuma hatası oluştu"));
            };
            
            reader.onloadend = () => {
                try {
                    let textContent = reader.result;
                    if (!textContent) {
                        return reject(new Error("Dosya içeriği okunamadı"));
                    }
                    
                    //@ts-ignore
                    if (textContent.substr(0, 2) == "PK") {
                        return resolve(blobData);
                    } else {
                        /**
                         * 08/04/2019
                         * uyap güncellemesi ile
                         * GELEN UDF zip olarak gelmiyor artık gelen xml datası mı diye text e çevirilip kontrol ediliyor.
                         * eğer zip olarak gelirse X tarihte ona göre de kontrol koyuldu.
                         * PK gelen data zip mi değilmi kontrolüdür..
                         * Emre
                         * @return zip blob data;
                         */
                        let zip = new JSZip();
                        zip.file("content.xml", blobData);
                        zip.generateAsync({
                            type: "blob",
                            compression: "DEFLATE",
                            compressionOptions: {
                                level: 6
                            }
                        }).then((content) => {
                            let blob = new Blob([content], {type: "application/octet-stream"});//udf type ına çeviriliyor.
                            console.log("UDF CONVERTING BLOB", blob);
                            return resolve({file: blob});
                        }).catch(function (err) {
                            return reject(err);
                        });
                    }
                } catch (error) {
                    return reject(error);
                }
            };
            
            reader.readAsText(data); //udf base64 ceviriliyor..
        })
    }

}
